import { ColumnProps } from './interface';

export default {
  name: 'ATableColumn',
  props: ColumnProps
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/table/Column.js
// module id = null
// module chunks = 